<template>
  <section class="quick-link">
    <ul class="row row_jsb">
      <li v-if="!isConnectedAtm" :style="getBackgroundColor('/atm/collect')">
        <a href="javascript:void(0)" @click="goMenu('/atm/collect')">
          <p class="ico"></p>
          <span>ATM 연결</span>
        </a>
      </li>
      <li v-if="!isConnectedAtm" :style="getBackgroundColor('/normal/collect')">
        <a href="javascript:void(0)" @click="goMenu('/normal/collect')">
          <p class="ico"></p>
          <span>일반 회수</span>
        </a>
      </li>
      <li v-if="isConnectedAtm" :style="getBackgroundColor('/atm/collect')">
        <a href="javascript:void(0)" @click="goMenu('/atm/collect')">
          <p class="ico"></p>
          <span>단말회수</span>
        </a>
      </li>
      <li v-if="isConnectedAtm" :style="getBackgroundColor('/customerCare/atmMntcHstrInsert')">
        <a href="javascript:void(0)" @click="goMenu('/customerCare/atmMntcHstrInsert')">
          <p class="ico"></p>
          <span>유지보수<br />수행</span>
        </a>
      </li>
      <li :style="getBackgroundColor('/customerCare/atmObstHstr')">
        <a href="javascript:void(0)" @click="goMenu('/customerCare/atmObstHstr')">
          <p class="ico ico-02"></p>
          <span>ATM<br>이상신고</span>
        </a>
      </li>
      <li :style="getBackgroundColor('/customerCare/atmMntcSchd')">
        <a href="javascript:void(0)" @click="goMenu('/customerCare/atmMntcSchd')">
          <p class="ico ico-03"></p>
          <span>유지보수<br>실적</span>
        </a>
      </li>
        <li :style="getBackgroundColor('/warehouse/stock/research')">
        <a href="javascript:void(0)" @click="goMenu('/warehouse/stock/research')">
          <p class="ico ico-02"></p>
          <span>재고조사</span>
        </a>
      </li>
    </ul>
  </section>
</template>

<script>
import isEmpty from 'lodash/isEmpty'

export default {
  name: 'QuickLink',
  components: {

  },
  data: () => ({

  }),
  computed: {
    getRoutePath () {
      return this.$route.path
    },
    getStoreAtmInfo () {
      return window.$store.getters['AtmWsStore/getResAtmInfo']
    },
    isConnectedAtm () {
      return !isEmpty(this.getStoreAtmInfo)
    }
  },
  created () {

  },
  mounted () {

  },
  watch: {

  },
  methods: {
    goMenu (menuUrlAddr) {
      this.$router.push({path: menuUrlAddr})
    },
    getBackgroundColor (trgtPath) {
      return {
        backgroundColor: trgtPath === this.getRoutePath ? 'gainsboro' : ''
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/QuickLink.vue